import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ImageWithCreds from "./components/ImageWithCreds";
import bgFigure from "./images/bgFigure.svg"
import {mediaQueries} from './shared/config';


const Container = styled.div`
    margin: auto;
    margin-bottom: 80px;
    ${mediaQueries.tablet} {
      margin-bottom: 40px;
	  }
    
`

const SubContainer = styled.div`
    margin-bottom: 40px;
    
`
const Title = styled.div`
    font-size: 50px;
    text-align: center;
    width: 60%;
    margin: 80px auto 40px auto;
    text-transform: uppercase;
    font-family: 'Playfair Display';
    font-weight: 700;
    color: white;
    ${mediaQueries.tablet} {
      margin: 40px auto 30px auto;
      font-size: 30px;
      width: 80%;
	}
`

const Byline = styled.div`
  font-size: 20px;
  text-align: center;
  width: 60%;
  margin: 5px auto;
  font-family: 'Playfair Display';
  font-weight: 500;
  color: white;
  font-style: italic;
  ${mediaQueries.tablet} {
      font-size: 15px;
      width: 80%;
	}
`

const Subheader = styled.div`
  font-size: 36px;
  text-align: center;
  width: 50%;
  margin: 20px auto;
  text-transform: uppercase;
  font-family: 'Playfair Display';
  font-weight: 800;
  color: white;
  letter-spacing: 10px;
  ${mediaQueries.tablet} {
      font-size: 20px;
      width: 80%;
	}
`

const Paragraph = styled.div`
  color: white;
  width: 70%;
  margin: auto;
  padding-bottom: 20px;
  text-align: left;
  font-family: 'PT Serif';
  font-size: 20px;
  ${mediaQueries.tablet} {
      font-size: 15px;
      width: 80%;
	}

`

const Image = styled.img`
  pointer-events: none;
  position: absolute;
  height: 100%;
  width:100%;
  z-index: -1;
`


function App() {
  const [ data, setData ] = useState(null);
  
  useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/flatpage.2022.medschool")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])

  data && console.log(data);

  return (
    (data &&
      <>
      <Header/>
      <Container>
        <Image src={bgFigure}/>
        <Title>{data.title}</Title>
        <SubContainer>
          <Byline>{data.byline}</Byline>
          <Byline>{data.byline_title}</Byline>
        </SubContainer>
        <Paragraph dangerouslySetInnerHTML={{__html: data.intro_text}}/>
        {data.before_interactive.map(block=>{
          if (block.type === 'paragraph'){
            return(
              <Paragraph dangerouslySetInnerHTML={{__html: block.content}}/>
            )
          }
          else if (block.type === 'section_name'){
            return(
              <Subheader>{block.content}</Subheader>
            )
          }
          else if(block.type === 'illo'){
            return(
              <ImageWithCreds src={block.image_link} name={block.image_credits}/>
            )
          }
        })}

        <iframe className="iframe" height="800" width="100%" frameBorder="0" title='charts' src="./interactive_chart/index.html"></iframe>

        {data.after_interactive.map(block=>{
          if (block.type === 'paragraph'){
            return(
              <Paragraph dangerouslySetInnerHTML={{__html: block.content}}/>
            )
          }
          else if (block.type === 'section_name'){
            return(
              <Subheader>{block.content}</Subheader>
            )
          }
          else if(block.type === 'illo'){
            return(
              <ImageWithCreds src={block.image_link} name={block.image_credits}/>
            )
          }
        })}
      </Container>
      <Footer/>
      </>
        )
      
      
  
  );
}

export default App;
